module.exports = __webpack_public_path__ + "static/media/about-img-2.6d27d2cd.jpg";